import React from 'react'
import {connectSearchBox} from 'react-instantsearch/connectors';
import Slider from 'react-rangeslider'

// class Horizontal extends Component {
class YearSlider extends React.Component {
  constructor (props, context) {
    super(props, context)
    this.state = {
      value: 1954,
      valueAsString: "1954"
    }
  }

  handleChangeStart = () => {
    //console.log('Change event started')
  };

  handleChange = value => {
    this.setState({
      value: value,
      valueAsString: value.toString()
    })
  };

  handleChangeComplete = () => {
    this.props.refine(this.state.valueAsString);
  };

  // oneUp = value => {
  //   console.log(this.state.valueAsString);
  //   this.setState({
  //     value: value,
  //     valueAsString: value.toString()
  //   })
  //   console.log(this.state.valueAsString);
  //   this.props.refine(this.state.valueAsString);
  // };
  render () {
    //const {currentRefinement, refine } = this.props;
    const { value } = this.state
    return (
      <div className='year-slider'>
        <h4 className='year-slider__heading'>{value}</h4>
        <Slider
          min={1878}
          max={2018}
          value={value}
          tooltip={false}
          onChangeStart={this.handleChangeStart}
          onChange={this.handleChange}
          onChangeComplete={this.handleChangeComplete}
        />
        {/* <div onClick={this.oneUp} value={value+1}>Next</div> */}
        {/* <div>2018</div> */}
      </div>
    )
  }
}

const YearSliderExport = connectSearchBox(YearSlider);

export default YearSliderExport;

// import React from 'react';
// import {connectSearchBox} from 'react-instantsearch/connectors';
// import Slider from 'react-rangeslider';
//
// class SearchBox extends React.Component {
//   constructor(props, context) {
//     super(props, context)
//     this.state = {
//       sliderValue: 20
//     }
//   }
//   handleOnChange = (value) => {
//     this.setState({
//       volume: value
//     })
//   }
//   // componentWillReceiveProps(sliderState) {
//   //
//   //    if (sliderState.canRefine) {
//   //       //this.setState({currentValues: {min: sliderState.currentRefinement.min, max: sliderState.currentRefinement.max}});
//   //       this.setState({currentValues: {min: sliderState.currentRefinement.min, max: sliderState.currentRefinement.min}});
//   //      //this.setState({currentValues: 1994});
//   //      //console.log("componentWillReceiveProps");
//   //    }
//   //  }
//   //
//   // onChange = (sliderState) => {
//   //     // if (this.props.currentRefinement.min !== sliderState.values[0] ||
//   //     //   this.props.currentRefinement.max !== sliderState.values[1]) {
//   //       console.log("onChange");
//   //
//   //       this.props.refine({currentRefinement: sliderState.value});
//   //
//   //       //this.props.refine({query: "1920"});
//   //   //  }
//   //   };
//   render(){
//   const {currentRefinement, refine } = this.props;
//   const { sliderValue } = this.state;
//     return(
//       <div className="search-box">
//         {/* <input
//           type="text"
//           value={currentRefinement}
//           onChange={e => refine(e.target.value)}
//           autoComplete="off"
//           className="search-input"
//          /> */}
//          <Slider
//           min={0}
//           max={100}
//           value={sliderValue}
//           //onChange={e => refine(e.target.value)}
//           //onChange={this.onChange}
//           onChange={this.handleOnChange}
//         />
//       </div>
//     )
//   }
// }
//
// const SearchInput = connectSearchBox(SearchBox);
//
// export default SearchInput;
// import React from 'react';
// import {connectCurrentRefinements} from 'react-instantsearch/connectors';
//
//
// class YearSearch extends React.Component {
//     // constructor(){
//     //   super();
//       //this.currentRefinement = this.currentRefinement.bind(this);
//       // this.loadSamples = this.loadSamples.bind(this);
//       // this.addToOrder = this.addToOrder.bind(this);
//
//       // get initial state
//     //   this.state = {
//     //     query: "hello2"
//     //   };
//     // }
//   //state = {query: {this.state.query} };
//
//   render() {
//     const {currentRefinement} = this.props;
//     const {query} = this.state;
//     //const {currentValues} = this.state;
//     return (
//       <div>
//         {currentRefinement}
//       </div>
//     )
//   }
// }
//
// const ConnectedRefine = connectCurrentRefinements(YearSearch);
//
// export default ConnectedRefine;
//
// import React from 'react';
// import {createConnector} from 'react-instantsearch';
// //import PropTypes from 'prop-types';
//
// const CoolWidget = createConnector({
//   displayName: 'YearSlider',
//
//   getProvidedProps(props, searchState) {
//     // Since the `queryAndPage` searchState entry isn't necessarily defined, we need
//     // to default its value.
//     const [query, page] = searchState.queryAndPage || ['', 0];
//
//     // Connect the underlying component to the `queryAndPage` searchState entry.
//     return {
//       query,
//       page,
//     }
//   },
//
//   refine(props, searchState, newQuery, newPage) {
//     // When the underlying component calls its `refine` prop, update the searchState
//     // with the new query and page.
//
//     return {
//       // `searchState` represents the search state of *all* widgets. We need to extend it
//       // instead of replacing it, otherwise other widgets will lose their
//       // respective state.
//       ...searchState,
//       queryAndPage: [newQuery, newPage],
//     };
//   },
//   getSearchParameters(searchParameters, props, searchState) {
//     // Since the `queryAndPage` state entry isn't necessarily defined, we need
//     // to default its value.
//     const [query, page] = this.state.queryAndPage || ['', 0];
//
//     // When the `queryAndPage` state entry changes, update the query and page of
//     // search.
//     return searchParameters
//       .setQuery(query)
//       .setPage(page);
//   },
// })(props =>
//   <div>
//     The query is {props.query}, the page is {props.page}.
//     {/*
//       Clicking on this button will update the searchState to:
//       {
//         ...otherSearchState,
//         query: 'algolia',
//         page: 20,
//       }
//     */}
//     <button onClick={() => props.refine('algolia', 20)} />
//     {/*
//       Clicking on this button will update the searchState to:
//       {
//         ...otherSearchState,
//         query: 'instantsearch',
//         page: 15,
//       }
//     */}
//     <button onClick={() => props.refine('instantsearch', 15)} />
//   </div>
// );
// //const Slider = createConnector(YearSearch);
//
//
// export default CoolWidget;
// class CoolWidget extends React.Component {
//   static propTypes = {
//      page: PropTypes.number,
//      query: PropTypes.string,
//      // currentRefinement: PropTypes.object,
//      // refine: PropTypes.func.isRequired,
//      // canRefine: PropTypes.bool.isRequired,
//    };
//   getProvidedProps(props, searchState) {
//     // Since the `queryAndPage` searchState entry isn't necessarily defined, we need
//     // to default its value.
//     const [query, page] = searchState.queryAndPage || ['', 0];
//
//     // Connect the underlying component to the `queryAndPage` searchState entry.
//     return {
//       query,
//       page,
//     }
//   }
//
//   getSearchParameters(searchParameters, props, searchState) {
//       // Since the `queryAndPage` state entry isn't necessarily defined, we need
//       // to default its value.
//       const [query, page] = this.state.queryAndPage || ['', 0];
//
//       // When the `queryAndPage` state entry changes, update the query and page of
//       // search.
//       return searchParameters
//         .setQuery(query)
//         .setPage(page);
//     }
//
//   refine(props, searchState, newQuery, newPage) {
//     // When the underlying component calls its `refine` prop, update the searchState
//     // with the new query and page.
//
//     return {
//       // `searchState` represents the search state of *all* widgets. We need to extend it
//       // instead of replacing it, otherwise other widgets will lose their
//       // respective state.
//       ...searchState,
//       queryAndPage: [newQuery, newPage],
//     };
//   }
//
//   render(){
//     const {page, query} = this.props;
//     //const {page, query} = this.state;
//       return (
//   <div>
//     The query is {this.props.query}, the page is {this.props.page}.
//     {/*
//       Clicking on this button will update the searchState to:
//       {
//         ...otherSearchState,
//         query: 'algolia',
//         page: 20,
//       }
//     */}
//     <button onClick={() => this.props.refine('algolia', 20)} />
//     {/*
//       Clicking on this button will update the searchState to:
//       {
//         ...otherSearchState,
//         query: 'instantsearch',
//         page: 15,
//       }
//     */}
//     <button onClick={() => this.props.refine('instantsearch', 15)} />
//   </div>
//   )
// }
// }
//
// const Slider = createConnector(CoolWidget);
//
// export default Slider;


// import React from 'react';
// import PropTypes from 'prop-types';
// //import Slider from 'react-rangeslider'
// //import {SearchBox} from 'react-instantsearch/dom';
// //import {Range} from 'react-instantsearch/dom';
// //import {MultiRange} from 'react-instantsearch/dom';
//
// //import {RefinementList} from 'react-instantsearch/dom';
// //import {connectRange} from 'react-instantsearch/connectors';
// //import {connectCurrentRefinements} from 'react-instantsearch/connectors';
// import {connectSearchBox} from 'react-instantsearch/connectors';
// //import Rheostat from 'rheostat';
// class YearSearch extends React.Component {
//   constructor (props, context) {
//       super(props, context)
//       this.state = {
//         value: "1994"
//       }
//     }
//   //   static propTypes = {
//   //    query: PropTypes.string,
//   //    refine: PropTypes.func.isRequired,
//   //    canRefine: PropTypes.bool.isRequired,
//   //  };
//   // handleChange = (value) => {
//   //   console.log(this.state.value);
//   //     this.setState({
//   //       value: value
//   //     })
//   //   };
// render () {
//   const {
//         value
//       } = this.state
//   return (
//     <div>
//       <input
//         currentRefinement="hello" />
//
//       {/* <button onClick={this.handleChange}>hello</button> */}
//     </div>
//   )
// }
// }
//   //export default SearchYear;
// const ConnectedCurrentRefinements = connectSearchBox(YearSearch);
// export default ConnectedCurrentRefinements;
//
// // import React from 'react';
// // import PropTypes from 'prop-types';
// // import Slider from 'react-rangeslider'
// // //import {SearchBox} from 'react-instantsearch/dom';
// // //import {Range} from 'react-instantsearch/dom';
// // //import {MultiRange} from 'react-instantsearch/dom';
// //
// // //import {RefinementList} from 'react-instantsearch/dom';
// // import {connectRange} from 'react-instantsearch/connectors';
// // //import {connectCurrentRefinements} from 'react-instantsearch/connectors';
// // //import Rheostat from 'rheostat';
// //
// // class YearSearch extends React.Component {
// //   // constructor (props, context) {
// //   //   super(props, context)
// //   //   this.state = {
// //   //     value: 1994
// //   //   }
// //   // }
// //   static propTypes = {
// //     value: PropTypes.number,
// //     min: PropTypes.number,
// //     max: PropTypes.number,
// //     currentRefinement: PropTypes.object,
// //     refine: PropTypes.func.isRequired,
// //     canRefine: PropTypes.bool.isRequired,
// //     //clearsQuery: PropTypes.func.isRequired
// //     //currentRefinement: PropTypes.object,
// //     // refine: PropTypes.func.isRequired,
// //     // canRefine: PropTypes.bool.isRequired,
// //   };
// //   // this.setState({
// //   //     value: 1994
// //   //   })
// //
// //   state = {currentValues: {min: this.props.value, max: this.props.value}, value: 1994};
// //   //state = {value: this.props.value, currentRefinement: this.props.value  };
// //
// //   // handleChange = value => {
// //   //   this.setState({value: value });
// //   //   this.setState({currentRefinement: value });
// //   // };
// //   componentWillReceiveProps(sliderState) {
// //      if (sliderState.canRefine) {
// //        console.log("componentWillReceiveProps");
// //        this.setState({currentValues: {min: sliderState.currentRefinement.min, max: sliderState.currentRefinement.min}});
// //      }
// //    }
// //    onValuesUpdated = (sliderState) => {
// //        console.log("onValuesUpdated ");
// //      this.setState({currentValues: {min: sliderState.values[0], max: sliderState.values[1]}});
// //    };
// //
// //    onChange = (sliderState) => {
// //       console.log(sliderState.currentRefinement);
// //      //
// //      // if (this.props.currentRefinement.min !== sliderState.values[0] ||
// //      //   this.props.currentRefinement.max !== sliderState.values[1]) {
// //        console.log("onChange");
// //        this.props.refine({min: sliderState.value, max: sliderState.value+1});
// //     // }
// //    };
// //   // handleChangeStart = () => {
// //   //   console.log('Change event started')
// //   // };
// //   //
// //   // handleChange = value => {
// //   //   this.setState({
// //   //     value: value
// //   //   })
// //   // };
// //   //
// //   // handleChangeComplete = () => {
// //   //   console.log('Change event completed')
// //   // };
// //
// //   render () {
// //     // const {
// //     //   min, max,
// //     //   currentRefinement
// //     //   //value
// //     // } = this.props
// //     // const {currentValues} = this.state;
// //     // // const {
// //     // //   currentRefinement: CurrentRefinement,
// //     // //   value
// //     // //
// //     // // } = this.state
// //     const {min, max, currentRefinement} = this.props;
// //     const {currentValues} = this.state;
// //     return min !== max ?
// //     //return (
// //       <div className='slider'>
// //         <Slider
// //           min={min}
// //           max={max}
// //           values={currentRefinement.min}
// //           //value={value}
// //           // onChangeStart={this.handleChangeStart}
// //           // onChange={this.handleChange}
// //           // onChangeComplete={this.handleChangeComplete}
// //           //values={[currentRefinement.min, currentRefinement.max]}
// //           onChange={this.onChange}
// //           onValuesUpdated={this.onValuesUpdated}
// //         />
// //         <div className='value'>{currentRefinement.min}</div>
// //       </div> : null;
// //     //)
// //
// //   }
// // }
// // const ConnectedRange = connectRange(YearSearch);
// //
// // export default ConnectedRange;
// //
// //
// //
// // //export default YearSearch
// // //
// // // handleChangeStart = () => {
// // //   console.log('Change event started')
// // // };
// // //
// // // handleChange = value => {
// // //   this.setState({
// // //     value: value
// // //   })
// // // };
// // //
// // // handleChangeComplete = () => {
// // //   console.log('Change event completed')
// // // };
// //
// //
// //
// // // const SearchYear = (props) => {
// // // class SearchYear extends React.Component {
// // //   static propTypes = {
// // //    min: PropTypes.number,
// // //    max: PropTypes.number,
// // //    currentRefinement: PropTypes.object,
// // //    refine: PropTypes.func.isRequired,
// // //    canRefine: PropTypes.bool.isRequired,
// // //  };
// // //
// // //  state = {currentValues: {min: this.props.min, max: this.props.max}};
// // //
// // //  componentWillReceiveProps(sliderState) {
// // //     if (sliderState.canRefine) {
// // //       this.setState({currentValues: {min: sliderState.currentRefinement.min, max: sliderState.currentRefinement.max}});
// // //     }
// // //   }
// // //
// // //   onValuesUpdated = (sliderState) => {
// // //     this.setState({currentValues: {min: sliderState.values[0], max: sliderState.values[1]}});
// // //   };
// // //
// // //   onChange = (sliderState) => {
// // //     if (this.props.currentRefinement.min !== sliderState.values[0] ||
// // //       this.props.currentRefinement.max !== sliderState.values[1]) {
// // //       this.props.refine({min: sliderState.values[0], max: sliderState.values[1]});
// // //     }
// // //   };
// // //  render() {
// // //   const {min, max, currentRefinement} = this.props;
// // //   const {currentValues} = this.state;
// // //   return min !== max ?
// // //     <div>
// // //       <Rheostat
// // //         min={min}
// // //         max={max}
// // //         values={[currentRefinement.min, currentRefinement.max]}
// // //         onChange={this.onChange}
// // //         onValuesUpdated={this.onValuesUpdated}
// // //       />
// // //     <div style={{display: 'flex', justifyContent: 'space-between'}}>
// // //           <div>{currentValues.min}</div>
// // //           <div>{currentValues.max}</div>
// // //         </div>
// // //       </div> : null;
// // //   }
// // // }
// // // //export default SearchYear;
// // // const ConnectedRange = connectRange(SearchYear);
// // //
// // // export default ConnectedRange;



// WEBPACK FOOTER //
// ./src/components/YearSlider.js